import { combineReducers } from 'redux'
import trainedModelReducer from './trainedModelReducer'

export default combineReducers({
    trainedModel: trainedModelReducer
})